/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {useCallback, useState} from "react";
import {FormControl} from "react-bootstrap";
import {ObjectUtils} from "../../../Utils/ObjectUtils";
import {useDebouncedEffect} from "../../../Hooks/EffectHooks";

export const JsonFieldEditor = function (props) {
    
    const { FieldDef, OnUpdate, Value } = props;
    
    const [value, setValue] = useState(Value);
    const onBlurOrChange = useCallback(
        (x) => {
            setValue(x.target.value);
        },
        [setValue]
    );
    
    useDebouncedEffect(() => {
        if (ObjectUtils.IsJson(value)) {
            OnUpdate(JSON.parse(value));
        } else {
            OnUpdate((typeof value === 'string' && value.trim() === '') ? null : value);
        }
    }, [value])
    
    const displayValue = () => {
        if (value === null) {
            return "";
        }
        
        if (typeof value === 'object') {
            return JSON.stringify(value, undefined, 2);
        }
        
        return value;
    }
    
    return <FormControl
        className="json-field-editor"
        as="textarea"
        value={displayValue()}
        onChange={onBlurOrChange}
        onBlur={onBlurOrChange}
        placeholder={FieldDef.placeholder}
    />;
};
